import { configsModule } from './store/configs'
import { createModule } from '@vue-storefront/core/lib/module'

export const CONFIGS_KEY = 'configs'
export const Configs = createModule({
  key: CONFIGS_KEY,
  store: {
    modules: [
      {
        key: CONFIGS_KEY,
        module: configsModule
      }
    ]
  }
})
